import { render, staticRenderFns } from "./PokemonDetail.vue?vue&type=template&id=5b8a0b4a&scoped=true&"
import script from "./PokemonDetail.vue?vue&type=script&lang=js&"
export * from "./PokemonDetail.vue?vue&type=script&lang=js&"
import style0 from "./PokemonDetail.vue?vue&type=style&index=0&id=5b8a0b4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8a0b4a",
  null
  
)

export default component.exports